import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useIntl } from 'react-intl-next';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';
import { useAnalyticsFlowEventsQueue } from '../../analytics/analytics-flow/analyticsFlowUtils';
import globalMessages from '../../messages';
import { useAIExperienceCommonDataContext } from '../useAIExperienceCommonData';
export function FailedScreenWithLogic(_ref) {
  var failureReason = _ref.failureReason,
    errorInfo = _ref.errorInfo;
  var aiExperienceCommonData = useAIExperienceCommonDataContext();
  var endExperience = aiExperienceCommonData.endExperience;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var knownErrorMessages = {
    'unknown fail': globalMessages.documentInsertError,
    'token limit fail': globalMessages.tokenLimitExceeded,
    'insert failure': globalMessages.documentInsertError,
    'input too short fail': globalMessages.inputTooShortError,
    'hipaa content fail': globalMessages.hipaaContentError
  };
  var errorType = failureReason || 'unknown fail';
  var errorMessage = formatMessage(knownErrorMessages[errorType]);
  useAnalyticsFlowEventsQueue({
    stepName: 'failed',
    attributes: _objectSpread({
      errorType: errorType
    }, errorInfo)
  });
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    text: errorMessage,
    onCancel: function onCancel() {
      endExperience();
    }
  });
}